/**
 * Custom key to manage infinite animations
 */
export const getElementKeyDatasetForInfiniteAnimation = (
  activeElementIndex: number,
  currentElementIndex: number,
  numberOfElements: number,
) => {
  if (currentElementIndex === activeElementIndex) {
    return 0;
  }

  if (currentElementIndex - activeElementIndex > 0) {
    if (
      currentElementIndex - activeElementIndex >
      Math.floor(numberOfElements / 2)
    ) {
      /**
       * If the element is after the selected one and if further away than half the slider's slides length
       * return a negative value by getting the element index and subtracting the difference between the slider's slides length and the selected index
       */
      return currentElementIndex - numberOfElements - activeElementIndex;
    }
  } else if (
    currentElementIndex - activeElementIndex <
    -1 * Math.floor(numberOfElements / 2)
  ) {
    /**
     * If the element is before the selected one and if further away than half the slider's slides length
     * return a negative value by getting the element index and adding the difference between the slider's slides length and adding the selected index
     */
    return currentElementIndex + numberOfElements - activeElementIndex;
  }

  return currentElementIndex - activeElementIndex;
};
